import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '../../../core/i18n';
import { ArticleCarouselModule } from '../article-carousel';
import { NotificationModule } from '../notification';
import { OrderEntrySimilarArticlesComponent } from './order-entry-similar-articles.component';

@NgModule({
  imports: [CommonModule, I18nModule, NotificationModule, ArticleCarouselModule],
  declarations: [OrderEntrySimilarArticlesComponent],
  exports: [OrderEntrySimilarArticlesComponent],
})
export class OrderEntrySimilarArticlesModule {}
